import { RatingTicketPhase } from '../../types/Rating/RatingTypes';

export const isInServicePhaseAllowed = (
  phases: RatingTicketPhase[] | undefined,
  ticketPhase?: RatingTicketPhase | null
): boolean => {
  if (!phases?.length) {
    return false;
  }
  return ticketPhase != null && phases.includes(ticketPhase);
};
